import axios from 'axios';
import { LOG_URL, LOG_BASE_URL, CLASSTING_FULL_AUTH_URL } from '@/config';
import Mobile from '@/mixins/Mobile';

function sendApiLog(res, store) {
  try {
    if (!res || !res.config || !res.config.url || res.config.url.indexOf('wlog') !== -1) {
      return;
    }

    const user = store.getters.currentUser || {};
    const now = new Date();
    const body = {
      method: res.config.method,
      api: res.config.url,
      code: res.status,
      uid: user.id,
      role: user.role,
      grade: user.grade_id,
      device: Mobile.methods.getDeviceName(),
      device_model: window.navigator.userAgent,
      client_time: now.getTime(),
      origin: `${window.location.origin}${window.location.pathname}`,
      host: window.location.host,
      msg: (res.data || {}).error_description,
    };

    const parentIds = store.getters.getRouteQuery.parent_ids;

    if (parentIds) {
      const parentIdList = parentIds.split(',');

      parentIdList.forEach((parentId, i) => {
        body[`parent_id${i + 1}`] = parentId;
      });
    }

    axios.post(LOG_URL, body);
  } catch (err) {
    console.error('failed to send log with err:', err);
  }
}


export function sendCardRatingLog(ratingInfo, user, isStoreCard) {
  return Promise.resolve()
    .then(() => {
      const logType = isStoreCard ? 'store_card_rating' : 'card_rating';
      const body = {
        card_id: ratingInfo.card_id,
        uid: ratingInfo.user_id,
        assignment_id: ratingInfo.assignment_id,
        client_time: (new Date()).getTime(),
        rating: ratingInfo.rating,
        device: Mobile.methods.getDeviceName(),
        origin: `${window.location.origin}${window.location.pathname}`,
        host: window.location.host,
        role: user.role,
        grade: user.grade_id,
      };

      return axios.post(`${LOG_BASE_URL}_${logType}`, body);
    })
    .catch((err) => {
      console.error('failed to send rating log with err:', err);
    });
}

function rfreshAuthorize() {
  sessionStorage.setItem('continue_url', window.location.pathname);
  window.location.href = CLASSTING_FULL_AUTH_URL;
}

export default (http, store) => {
  http.interceptors.response.use(
    (response) => {
      sendApiLog(response, store);
      return response;
    },

    (error) => {
      const { response } = error;

      if (response && response.status === 401) {
        rfreshAuthorize();
      }

      return Promise.reject(error);
    },
  );
};
